import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type DevToolsMode = 'off' | 'on' | 'eruda'

interface DevToolsState {
	/** Set once by the 20-tap gesture on the Каталог header; persists forever. */
	unlocked: boolean
	/** off = hidden, on = floating icon, eruda = eruda's own panel instead. */
	mode: DevToolsMode
	/** Bottom sheet visibility; intentionally not persisted. */
	sheetOpen: boolean
	/** Passcode modal visibility; intentionally not persisted. */
	passcodeModalOpen: boolean
	/** Last dragged position of the floating icon. */
	iconPos: { x: number; y: number }

	unlock: () => void
	setMode: (mode: DevToolsMode) => void
	setSheetOpen: (sheetOpen: boolean) => void
	setPasscodeModalOpen: (open: boolean) => void
	setIconPos: (iconPos: { x: number; y: number }) => void
}

export const useDevToolsStore = create<DevToolsState>()(
	persist(
		(set) => ({
			unlocked: false,
			mode: 'on',
			sheetOpen: false,
			passcodeModalOpen: false,
			iconPos: { x: 12, y: 160 },

			// First unlock also turns the panel on.
			unlock: () => set({ unlocked: true, mode: 'on' }),
			setMode: (mode) => set({ mode }),
			setSheetOpen: (sheetOpen) => set({ sheetOpen }),
			setPasscodeModalOpen: (passcodeModalOpen) => set({ passcodeModalOpen }),
			setIconPos: (iconPos) => set({ iconPos }),
		}),
		{
			name: '@devtools',
			partialize: (state) => ({
				unlocked: state.unlocked,
				mode: state.mode,
				iconPos: state.iconPos,
			}),
			// If @devtools has never been set in localStorage, default mode to 'on'
			// after zustand hydration. If it exists, the persisted value is respected.
			onRehydrateStorage: () => (state) => {
				if (!state) return
				const raw = localStorage.getItem('@devtools')
				if (!raw) {
					state.mode = 'on'
				}
			},
		},
	),
)
